<template>
<!-- 新增部门 -->
  <el-dialog
    :title="$t('pages.system.text105')"
    :visible.sync="addVisible"
    width="650px"
    :before-close="handleClose"
    :close-on-click-modal="false"
  >
    <div class="from-body">
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="auto"
        class="demo-ruleForm"
        :rules="rules"
      >
        <el-form-item :label="$t('pages.system.text106')" prop="departmentName">
          <el-input v-model="ruleForm.departmentName"></el-input>
        </el-form-item>
        <el-form-item :label="$t('pages.system.text107')" prop="departmentDesc">
          <el-input
            type="textarea"
            rows="4"
            v-model="ruleForm.departmentDesc"
          ></el-input>
        </el-form-item>
      </el-form>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{$t('button.cancel')}}</el-button>
      <el-button type="primary" @click="submit">{{$t('button.determine')}}</el-button>
    </span>
  </el-dialog>
</template>


<script>
import { validatName, validatDescribe } from "../../../../utils/util/test";
import { mapState } from "vuex";
export default {
  data() {
    return {
      ruleForm: {
        belongCustomerId: "", //客户id
        departmentDesc: "", //部门描述
        departmentName: "", //部门名称
        sort: 0, //排序
      },
      rules: {
        departmentName: [{ validator: validatName, trigger: "blur" }],
        departmentDesc: [{ validator: validatDescribe, trigger: "blur" }],
      },
    };
  },
  props: ["addVisible"],
  computed: {
    ...mapState(["platformData"]),
  },
  methods: {
    //取消
    handleClose() {
      this.ruleForm.departmentDesc = ""; //部门描述
      this.ruleForm.departmentName = ""; //部门名称
      this.$refs['ruleForm'].resetFields();
      this.$emit("addClose");
    },
    //确定
    submit() {
      this.ruleForm.belongCustomerId = this.platformData.id;
      this.$refs["ruleForm"].validate((valid) => {
        if (valid) {
          this.request.departmentManagementAdd(this.ruleForm).then(() => {
            this.$message.success(this.$t('pages.system.text108'));
            this.$emit("departmentManagementListAll");
            this.handleClose();
          });
        }
      });
    },
  },
};
</script>

<style scoped>
.from-body {
  padding: 0 40px;
  box-sizing: border-box;
}
</style>